import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/MaintainAccess.css';

import { SupplierUserPopUp } from '../components/SupplierUserPopUp';
import { TableRoleDisplay } from '../components/TableRoleDisplay';
import DataTable from 'react-data-table-component';
import { Loading } from '../components/Loading';
import RoleUtils from '../utils/roleUtils.js';
import CommonUtils from '../utils/siteUtils.js';
import { ConfirmModal } from '../components/ConfirmModal';
import ServiceCalls from '../utils/serviceCalls.js';
import { OHCIDDetailsPopUp } from '../components/OHCIDDetailsPopUp';


export class AdditionalUsersTable extends Component {

    constructor(props) {
        super(props)
        this.handleClose = this.handleClose.bind(this);
        this.handleRoleClose = this.handleRoleClose.bind(this);
        this.onUserUpdate = this.onUserUpdate.bind(this);
        this.state = {
            additionalUsers: [],
            data: [],
            pending: true,
            componentLoaded: false,
            rows: [],
            statusChange: false,
            roleChange: false,
            statusCapture: true,
            statusContactIdCapture: null,
            roleStatusCapture: 0,
            roleContactIdCapture: null,
        }
    }

    //Get additional users on mount and populate table
    componentDidMount() {
        if (this.props.onAdminFetched || this.props.isSupplierUpdated ===false) {
            //DEBUG  
            console.log(`In AdditionalUserTables mount -  SPUA email: ${this.props.spuaEmail}`);
            this.getAdditionalUsers();
        }
        else {
            //DEBUG console.log(`In AdditionalUserTables mount - no SPUA email: ${this.props.spuaEmail}`);
        }
    }

    //Get additional users again when companyId changes
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currentCompanyId !== this.props.currentCompanyId || (this.props.userAdded === true && this.state.componentLoaded === false)
            || (prevProps.spuaEmail !== this.props.spuaEmail) || ((prevProps.onAdminFetched !== this.props.onAdminFetched) && this.state.componentLoaded ===false)) {
            //DEBUG
            console.log(`In Additional users - Company changed from ${prevProps.currentCompanyId} to ${this.props.currentCompanyId}  or user added ${this.props.userAdded} or Admin Fetched: ${this.props.onAdminFetched}`);

            this.getAdditionalUsers();
        }
    }

    //Call server side function to get any additional users for a supplier
    getAdditionalUsers() {
        const { currentCompanyId } = this.props;
        if (!this.state.pending) {
            this.setState({
                pending: true,
                componentLoaded:true
            });
        }
        ServiceCalls.getAdditionalUsers(currentCompanyId).then(function (data) {
            if (data) {              
                this.setState({
                    additionalUsers: data,
                    pending: false,
                    showAddUser: true
                });
            }
            else {
                //update not successful. - need to handle
                this.setState({ pending: false });
            }
        }.bind(this));  
    }

    onUserUpdate = () => {
        this.setState({ pending: true });
       this.getAdditionalUsers();
    }


    //Populate table with additional users by creating an array of JSON users
    populateTable() {
        const tempArr = [];
        if (this.state.additionalUsers) {
            for (let i = 0; i < this.state.additionalUsers.length; i++) {
              // var roleId = this.state.additionalUsers[i].roleId;
                var contact = this.state.additionalUsers[i];
                //Create new JSON user to create a row
                var newUser = {
                    lastName: (contact.lastName === '' || contact.lastName == null ? "--" : contact.lastName),
                    firstName: (contact.firstName === '' || contact.firstName == null ? "--" : contact.firstName),
                    emailAddress: contact.email,
                   // securityRole: RoleUtils.roleIntToName(contact.suppliers[0].contactRoles[0].roleId), //  this.state.additionalUsers[i].roleId
                    lastSignOnDate: CommonUtils.renderStatusDate(contact.lastSignOnDate),
                    status: CommonUtils.statusNameForContact(contact), //this.buildStatus(this.state.additionalUsers[i]),
                    statusDate: CommonUtils.renderStatusDate(contact.statusDate),
                    contactId: contact.contactId,
                    roles: contact.suppliers[0].contactRoles,  //CommonUtils.buildRoleList()
                    registration: contact.ohcidRegistration,
                    statusNotes: '',//this.state.additionalUsers[i].statusNotes,
                    active:contact.profileStatus
                }
                tempArr.push(newUser);
            }
        }
        return tempArr;
    }

    ////Build proper security dropdown view based on user role
    //buildSecurityStatus(user) {
    //    const { currentUser, currentCompanyId } = this.props;
    //    var adminPerms = RoleUtils.optumAdminPerms();
    //    var canView = RoleUtils.canAccess(currentUser, currentCompanyId, adminPerms);
    //    var supplierAdmin = ["Supplier_Admin"];
    //    var canViewSAdmin = RoleUtils.canAccess(currentUser, currentCompanyId, supplierAdmin);
    //    var stringRoleId = role.displayName;

    //    //Phase 1 - only 1 role available, which is set on Add user.  Just display users current role
    //    return (
    //                <div className="title-select-access">
    //                    {stringRoleId}
    //                </div >
    //         );
    //}

    //Add pagination to table only if more than 10 rows
    conditionalPagination() {
        if (this.state.additionalUsers.length < 11) {
            return false;
        }
        return true;
    }

    //Handle close method for confirmModal (status dropdown)
    handleClose() {
        this.setState({
                statusChange: false
            });
    }

    //Handle close method for confirmModal (role drop down)
    handleRoleClose() {
        this.setState({roleChange: false});
    } 

    render() {
        const { currentUser, currentCompanyId, spuaEmail, isSupplierUpdated } = this.props;
        if (this.state.pending && isSupplierUpdated) {
            return (
                <>
                    <Row>
                        <Col xs={12}><h3 className="access-headers">Additional Users</h3></Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Container fluid className="searchInputAreas border-left-dark shadow borderCurve">
                                <div style={{ margin: "auto", width: "200px" }}>
                                    <Loading />
                                </div>
                            </Container>
                        </Col>
                    </Row>
                </>
            );
        }

        //if call to controller is complete, then populate table.  Set state in populateTable will cause a re-render of component.
        const userTbl = (this.state.pending && isSupplierUpdated) ? [] : this.populateTable();
        //Message to be passed in as prop to confirm modal
        var statusMsg = 'Are you sure you want to change this user\'s status to active?';
        var roleMsg = 'Are you sure you want to change this user\'s role?';
        if (this.state.statusCapture === false) {
            statusMsg = 'Are you sure you want to change this user\'s status to inactive?';
        }

        var isSPUA = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.supplierPortalUserAdminPerm());
        //var isAdminView = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms());
        var isSPUAView = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allAdminPerms());
        //<AddUser key={currentCompanyId} onUserAdd={this.props.onUserAdded} currentUser={this.props.currentUser} currentCompanyId={this.props.currentCompanyId} spuaEmail={spuaEmail}/>
        var addUserBtn = (isSPUAView) ? <SupplierUserPopUp btnClass="sAddBtn" key={currentCompanyId} editMode="Add" isSPUAView={false} currentContact={null} onUserAction={this.onUserUpdate} currentUser={this.props.currentUser} currentCompanyId={this.props.currentCompanyId} spuaEmail={spuaEmail} /> : <></>;

        var columns = [
            {
                name: 'Last Name',
                selector: row => row.lastName,
            },
            {
                name: 'First Name',
                selector: row => row.firstName,
            },
            {
                name: 'Email Address',
                selector: row => (
                    <div className="access-breakWord">
                        {row.emailAddress}
                    </div>
                ),
                wrap: true,
                grow: 2
            },
            {
                name: 'Security Role',
                grow: 2,
                cell: row => {
                    return (row.roles) ? <TableRoleDisplay roles={row.roles} /> :<></>                       
                },

            },
            {
                name: 'Last SignOn Date',
                selector: row => row.lastSignOnDate,
                maxwidth: "150px",
            },
            {
                name: 'Status',
                selector: row => row.status,
                maxwidth: "60px",
            },
            {
                name: 'Updated Date',
                selector: row => row.statusDate,
                maxwidth: "150px",
          },   
            {
                cell: row => {
                    //<UpdateUserPopUp key={row.emailAddress} currentUser={currentUser} editUser={row} currentCompanyId={this.props.currentCompanyId} onUserUpdate={this.onUserUpdate} spuaEmail={this.props.spuaEmail}></UpdateUserPopUp>
                    //pre 6-12  (isSPUAView && row.status.toLowerCase().includes("active"))
                    return (isSPUAView && (row.registration.statusId === 4 || row.registration.statusId === 5))
                        ? <SupplierUserPopUp key={row.emailAddress} editMode="Edit" isSPUAView={false} btnClass="sEditBtn" currentUser={currentUser} currentContact={row} onUserAction={this.onUserUpdate} currentCompanyId={this.props.currentCompanyId} spuaEmail={spuaEmail} />
                        :<></>;
                },
                right: "true",
                maxwidth: "150px",

            },
            {
                cell: row => {
                    var canShowPopup;
                    if(isSPUA){
                        canShowPopup = CommonUtils.statusNameForOHCIDDetails(row.registration, isSPUA) === "SPUA Invite";
                    }
                    else{
                        canShowPopup = CommonUtils.statusNameForOHCIDDetails(row.registration) === "Not New";
                    }

                   return canShowPopup ? (
                        <OHCIDDetailsPopUp
                            key={row.emailAddress}
                            userEmail={row.emailAddress}
                            refreshTable={this.onUserUpdate}
                            status={row.status}
                            inviteType={row.registration.inviteMessages}
                            currentUser={this.props.currentUser}
                            currentCompanyId={this.props.currentCompanyId}
                            isSPUA={isSPUA}
                        />
                    ) : null;
                },
                right: "true",
                maxwidth: "170px",
          }
            //{
            //    name: 'Locked',
            //    selector: row => row.locked,
            //},
            //{
            //    name: 'Locked Date',
            //    selector: row => row.lockedDate,
            //}
        ];
        return (
             <><Row>
                <Col xs={11}><h3 className="access-headers">Additional Users</h3></Col>
             
                <Col xs={1}>{addUserBtn}</Col>
            </Row>
                <Row>
                    <Col>
                <ConfirmModal message={statusMsg} isOpen={this.state.statusChange} handleAccept={this.updateUserStatusInfo}  handleClose={this.handleClose} />
                <ConfirmModal message={roleMsg} isOpen={this.state.roleChange} handleAccept={this.updateUserRole} handleClose={ this.handleRoleClose } /> 
                
                        <Container fluid className="searchInputAreas border-left-dark shadow borderCurve bottomTable">
                    <DataTable
                                columns={columns}
                        data={userTbl}  //this.state.rows
                        progressPending={this.state.pending}
                                progressComponent={<div style={{ margin: "auto", width: "200px" }}>
                                    <Loading />
                                </div>}
                        pagination={this.conditionalPagination()}
                    />
                        </Container>
                    </Col>
                </Row>
                <Row>
                    <Col>{/*<h3></h3>*/}</Col>
                </Row>
            </>
        )
    }
}
